import { FC } from "react"
import clsx from "clsx"
import { Link } from "react-router-dom"
import { useLocation } from "react-router"
import { checkIsActive, KTSVG, WithChildren } from "../../../../helpers"

type Props = {
     to: string
     target?: "_self" | "_blank"
     title: string
     icon?: string
     fontIcon?: string
     hasBullet?: boolean
     iconColor?: "text-warning" | "text-danger" | "text-primary" | "text-success"
     onClickCallback?: () => void
     iconClassName?: string
     linkClassName?: string
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
     children,
     to,
     target = "_self",
     title,
     icon,
     fontIcon,
     hasBullet = false,
     iconColor,
     iconClassName = "",
     linkClassName = "",
     onClickCallback = () => {},
}) => {
     const { pathname } = useLocation()
     // Only check active state if it's not an external link
     const isExternal = to.startsWith("http")
     const isActive = !isExternal && checkIsActive(pathname, to)

     // Common content inside the link
     const linkContent = (
          <>
               {hasBullet && (
                    <span className="menu-bullet">
                         <span className="bullet bullet-dot"></span>
                    </span>
               )}
               {icon && (
                    <span className="menu-icon">
                         {" "}
                         <KTSVG path={icon} className={`svg-icon-2 ${iconColor} ${iconClassName}`} />
                    </span>
               )}
               {fontIcon && <i className={clsx("fs-3 text-white text-center", fontIcon, iconClassName)} style={{ width: "23px" }}></i>}
               <span className="menu-title ms-2">{title}</span>
          </>
     )

     return (
          <div className="menu-item" onClick={onClickCallback}>
               {isExternal ? (
                    /* Render standard <a> tag for external links */
                    <a className={clsx("menu-link without-sub", linkClassName)} href={to} target={target} rel={target === "_blank" ? "noopener noreferrer" : undefined}>
                         {linkContent}
                    </a>
               ) : (
                    /* Render Router <Link> for internal navigation */
                    <Link className={clsx("menu-link without-sub", linkClassName, { active: isActive })} to={to} target={target}>
                         {linkContent}
                    </Link>
               )}
               {children}
          </div>
     )
}

export { SidebarMenuItem }
